export const LIST_LAYERS_ENDPOINT = '/api/layers';
export const GET_SINGLE_LAYER_ENDPOINT = '/api/layer';
export const GET_LOCATION_DATA_ENDPOINT = '/api/location-data';
